import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

let _ = t => t,
    _t;

import styled from 'styled-components';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UIImage from 'UIComponents/image/UIImage';
import UIBox from 'UIComponents/layout/UIBox';
import UIFlex from 'UIComponents/layout/UIFlex';
import { getUpgradePointImage } from 'ui-addon-upgrades/ums/getUpgradePointImage';
import breakpoint from 'pricing-pages-ui/js/constants/Breakpoints';
import ApiNameToUpgradeProductMap from 'self-service-api/constants/ApiNameToUpgradeProductMap';
import { CRM_SUITE_STARTER_BUNDLE } from 'self-service-api/constants/ApiNames';
import { GENERAL } from 'self-service-api/constants/UpgradeProducts';
import { ASSIGN_SEAT, REQUEST_SEAT } from 'ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes';
import { validateModalUpgradeConfig } from 'ui-addon-upgrades/ums/utils';
import Screens from '../../constants/routing/Screens';
import { APP } from '../../constants/tracking/App';
import SuiteStarterCard from '../merch-card/SuiteStarterCard';
import AddonPanel from './AddonPanel';
import AssignSeatPanel from './AssignSeatPanel';
import FeatureContent from './FeatureContent';
import GetPersonalizedPPPurchaseMotions, { shouldOverrideToPPRedirectPM } from './GetPersonalizedPPPurchaseMotions';
import PPPMerchCard from './PPPMerchCard';
import RequestSeatPanel from './RequestSeatPanel';
const FlexContainer = styled(UIFlex).withConfig({
  displayName: "UpgradeConfigContent__FlexContainer",
  componentId: "sc-1y4top4-0"
})(["z-index:1;padding-top:64px;", ";"], breakpoint.tablet(_t || (_t = _`
    padding-right: 48px;
    padding-left: 48px;
  `)));
const ImageWrapper = styled.div.withConfig({
  displayName: "UpgradeConfigContent__ImageWrapper",
  componentId: "sc-1y4top4-1"
})(["text-align:center;margin:0 auto;"]);

const getImage = upgradeConfig => {
  try {
    validateModalUpgradeConfig(upgradeConfig);
  } catch (e) {
    console.error(e);
    return /*#__PURE__*/_jsx(ImageWrapper, {});
  }

  if (!upgradeConfig || upgradeConfig && upgradeConfig.visualType && !upgradeConfig.visualKey) {
    return /*#__PURE__*/_jsx(ImageWrapper, {});
  }

  if (upgradeConfig && upgradeConfig.visualType === 'image') {
    return /*#__PURE__*/_jsx(ImageWrapper, {
      children: /*#__PURE__*/_jsx(UIImage, {
        style: {
          margin: '0 auto'
        },
        src: getUpgradePointImage(upgradeConfig.visualKey)
      })
    });
  }

  return /*#__PURE__*/_jsx(ImageWrapper, {
    children: /*#__PURE__*/_jsx(UIIllustration, {
      name: upgradeConfig.visualKey,
      height: 450
    })
  });
};

const PANEL_STATES = {
  SHOW_PURCHASE_MOTIONS: 'SHOW_PURCHASE_MOTIONS',
  SHOW_REQUEST_SEAT: 'SHOW_REQUEST_SEAT',
  SHOW_ASSIGN_SEAT: 'SHOW_ASSIGN_SEAT'
};

const getPurchaseMotionEligibilityToPanelState = purchaseMotionEligibility => {
  if (purchaseMotionEligibility.includes(ASSIGN_SEAT)) {
    return PANEL_STATES.SHOW_ASSIGN_SEAT;
  } else if (purchaseMotionEligibility.includes(REQUEST_SEAT)) {
    return PANEL_STATES.SHOW_REQUEST_SEAT;
  }

  return PANEL_STATES.SHOW_PURCHASE_MOTIONS;
};

const UpgradeConfigContent = ({
  upgradePointApiName,
  upgradeConfig
}) => {
  const upgradeData = {
    app: APP,
    screen: Screens.PERSONALIZED_PAGE,
    uniqueId: upgradeConfig.upgradeKey,
    upgradeProduct: ApiNameToUpgradeProductMap[upgradePointApiName] || GENERAL,
    apiName: upgradePointApiName
  }; // Temporary solution. See function details.

  const purchaseMotions = GetPersonalizedPPPurchaseMotions(upgradePointApiName);
  const panelState = getPurchaseMotionEligibilityToPanelState(purchaseMotions);

  const SelectedPanel = () => {
    if (panelState === PANEL_STATES.SHOW_PURCHASE_MOTIONS) {
      if (shouldOverrideToPPRedirectPM(upgradePointApiName)) {
        return /*#__PURE__*/_jsx(AddonPanel, {
          purchaseMotions: purchaseMotions,
          upgradeData: upgradeData
        });
      }

      if (upgradePointApiName === CRM_SUITE_STARTER_BUNDLE) {
        return /*#__PURE__*/_jsx(SuiteStarterCard, {});
      } else {
        return /*#__PURE__*/_jsx(PPPMerchCard, {
          upgradePointApiName: upgradePointApiName
        });
      }
    } else if (panelState === PANEL_STATES.SHOW_REQUEST_SEAT) {
      return /*#__PURE__*/_jsx(RequestSeatPanel, {
        purchaseMotions: purchaseMotions,
        upgradeData: upgradeData
      });
    } else if (panelState === PANEL_STATES.SHOW_ASSIGN_SEAT) {
      return /*#__PURE__*/_jsx(AssignSeatPanel, {
        purchaseMotions: purchaseMotions,
        upgradeData: upgradeData
      });
    } else {
      return null;
    }
  };

  return /*#__PURE__*/_jsxs(FlexContainer, {
    justify: "between",
    align: "center",
    children: [/*#__PURE__*/_jsxs(UIBox, {
      grow: 1,
      basis: "50%",
      className: "p-right-4",
      children: [/*#__PURE__*/_jsx(FeatureContent, {
        upgradeConfig: upgradeConfig,
        apiName: upgradePointApiName
      }), /*#__PURE__*/_jsx(SelectedPanel, {})]
    }), /*#__PURE__*/_jsx(UIBox, {
      grow: 0,
      basis: "50%",
      className: "p-left-4",
      children: getImage(upgradeConfig)
    })]
  });
};

export default UpgradeConfigContent;